'use client';
import { sendPv as sendPvHome } from '@/tracks/25223';
import { Home_Page_Code } from '@/constants/cms';

import { sendPv } from '../tempo_track';
import { sendPv as sendPvMiniHome } from '@/tracks/32401';
import { useEffect } from 'react';
interface PvProps {
  pageCode: string;
}
export default function PvModule({ pageCode }: PvProps) {
  useEffect(() => {
    if (pageCode === Home_Page_Code) {
      sendPvHome.Home_Main();
      return;
    } else if (location.pathname.startsWith('/minihome')) {
      sendPvMiniHome.Mini_Hp({ Mini_Hp_Name: pageCode, index: Number('-1') });
    } else {
      sendPv.cms_TempoPage({ page_id: pageCode });
    }
  }, [pageCode]);
  return null;
}
